import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { DOMAIN } from "../pages/admin/marketingShared";

export const HreflangTags: React.FC = () => {
  const { pathname } = useLocation();
  const { isRTL } = useLanguage();
  const url = `${DOMAIN}${pathname}`;

  return (
    <Helmet>
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="ar" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta property="og:locale" content={isRTL ? "ar_LB" : "en_US"} />
      <meta property="og:locale:alternate" content={isRTL ? "en_US" : "ar_LB"} />
    </Helmet>
  );
};
